let resumeData = {
    "imagebaseurl":"https://rbhatia46.github.io/",
    "name": "Smaller",
    "role": "React Frontend Developer",
    
    "roleDescription": "We are just a freelance company which is willing to anything to increase there development skills. (Who am I kidding I am all alone, this is what being alone feels like. Anyway my name is Sibongumusa and I am a react developer",
    "socialLinks":[
        
        {
          "name":"github",
          "url":"https://github.com/sibongumusa14",
          "className":"fa fa-github"
        },
        
      ],
    "aboutme":"My name is Sibongumusa, I am from South Africa and I code, like a lot! I am still in high school, but I am qualified to do what I do, After all you don't need a degree to code,  .",
    "address":"India",
    "website":"https://rbhatia46.github.io",
    "education":[
      {
        "UniversityName":"The LNM Insitute of Information Technology",
        "specialization":"Some specialization",
        "MonthOfPassing":"Aug",
        "YearOfPassing":"2020",
        "Achievements":"Some Achievements"
      },
      {
        "UniversityName":"Some University",
        "specialization":"Some specialization",
        "MonthOfPassing":"Jan",
        "YearOfPassing":"2018",
        "Achievements":"Some Achievements"
      }
    ],
    "work":[
      {
        "CompanyName":"Some Company",
        "specialization":"Some specialization",
        "MonthOfLeaving":"Jan",
        "YearOfLeaving":"2018",
        "Achievements":"Some Achievements"
      },
      {
        "CompanyName":"Some Company",
        "specialization":"Some specialization",
        "MonthOfLeaving":"Jan",
        "YearOfLeaving":"2018",
        "Achievements":"Some Achievements"
      }
    ],
    "skillsDescription":"Your skills here",
    "skills":[
      {
        "skillname":"HTML5"
      },
      {
        "skillname":"CSS"
      },
      {
        "skillname":"Reactjs"
      }
    ],
    "portfolio":[
      {
        "name":"project1",
        "description":"mobileapp",
        "imgurl":"images/portfolio/phone.jpg"
      },
      {
        "name":"project2",
        "description":"mobileapp",
        "imgurl":"images/portfolio/project.jpg"
      },
      {
        "name":"project3",
        "description":"mobileapp",  
        "imgurl":"images/portfolio/project2.png"
      },
      {
        "name":"project4",
        "description":"mobileapp",
        "imgurl":"images/portfolio/phone.jpg"
      }
    ],
    "testimonials":[
      {
        "description":"code cant lie, comments can",
        "name":"Unknown"
      },
      {
        "description":"While (!(succeed = try() ));",
        "name":"A positive Programmer"
      },
      {
        "description":"Always code as if the guy who ends up maintaining your code will be th a violet psychopath who knows where you live. ",
        "name":"Rick Osborne"
      },
      {
        "description":"Programming is like any other sport. You might know the rules but you have to play to learn",
        "name":"Zuckerberg"
      }
    ]
  }
  
  export default resumeData